// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "webpack/css/" + "styles" + "." + "bdc725c58f61b1c92b5c" + ".css";
};